import React from "react";
import { Box, Skeleton, Card, CardContent } from "@mui/material";

const SkeletonBarChart: React.FC = () => {
  return (
    <Card sx={{ margin: "0 auto", padding: 2 }}>
      <CardContent>
        <Skeleton variant="text" width="40%" sx={{ marginTop: 1, mb: 5 }} />
        <Box
          sx={{
            width: "100%",
            height: 400,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            {[...Array(5)].map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                sx={{ width: 20, height: 330 }}
              />
            ))}
          </Box>
          <Box sx={{ marginTop: 2 }}>
            <Skeleton variant="rectangular" width="100%" height={2} />
            <Skeleton variant="text" width="20%" sx={{ marginTop: 1 }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SkeletonBarChart;
